import NextCommitmentsCard from '@/routes/home/card/common/NextCommitmentsCard'
import ReminderCard from '@/routes/home/card/common/ReminderCard'
import FromYourAccountCard from '@/routes/home/card/common/FromYourAccountCard'
import CardMenu from '@/routes/home/card/CardMenu'
import { Person } from '@microsoft/mgt-react'
import { DashboardCardProps } from '@/routes/home/card/Card.types'
import { useMemo } from 'react'
import { Card } from '@/routes/home/card/Card.enums'
import OrdersToProcessCard from '@/routes/home/card/administrator/OrderToProcessCard'
import TasksToCompleteCard from '@/routes/home/card/tech-developer/TasksToCompleteCard'
import ActivitiesSummaryCard from '@/routes/home/card/common/ActivitiesSummaryCard'
import TicketsSummaryCard from '@/routes/home/card/tech-developer/TicketsSummaryCard'
import { useScreenSize } from '@/themes/media-query'
import AnalysisToCompleteCard from '@/routes/home/card/tech-developer/AnalysisToCompleteCard'

const DashboardCard = (props: DashboardCardProps) => {
  const {
    card,
    index,
    cardsVisible,
    cardsView,
    onRemoveMenuButtonClick,
    onMoveLeftMenuButtonClick,
    onMoveRightMenuButtonClick,
    onMoveDownMenuButtonClick,
    onMoveUpMenuButtonClick,
    getCurrentEmployee,
    maxCardsVisible,
  } = props

  const currentScreenSize = useScreenSize()

  const menuItems = useMemo(() => {
    return [
      { text: 'Rimuovi', icon: 'remove', onClick: onRemoveMenuButtonClick, visible: true },
      {
        text: 'Sposta',
        icon: 'arrowleft',
        onClick: onMoveLeftMenuButtonClick,
        visible:
          ((cardsVisible === 3 && ((index === 2 && cardsView) || (index === 1 && !cardsView))) ||
            (cardsVisible === maxCardsVisible && index === 1) ||
            index === 3) &&
          (currentScreenSize.isLarge || currentScreenSize.isMedium),
      },
      {
        text: 'Sposta',
        icon: 'arrowright',
        onClick: onMoveRightMenuButtonClick,
        visible:
          ((cardsVisible === 3 && ((index === 1 && cardsView) || (index === 0 && !cardsView))) ||
            (cardsVisible === maxCardsVisible && (index === 0 || index === 2))) &&
          (currentScreenSize.isLarge || currentScreenSize.isMedium),
      },
      {
        text: 'Sposta',
        icon: 'arrowup',
        onClick: onMoveUpMenuButtonClick,
        visible:
          (index === 2 || index === 3 || (index === 1 && ((cardsVisible === 3 && cardsView) || cardsVisible === 2))) &&
          (currentScreenSize.isLarge || currentScreenSize.isMedium),
      },
      {
        text: 'Sposta',
        icon: 'arrowdown',
        onClick: onMoveDownMenuButtonClick,
        screen: '',
        visible:
          ((index === 0 && cardsVisible > 1) ||
            (index === 1 && (cardsVisible === maxCardsVisible || (cardsVisible === 3 && !cardsView)))) &&
          (currentScreenSize.isLarge || currentScreenSize.isMedium),
      },
    ]
  }, [
    cardsView,
    cardsVisible,
    currentScreenSize,
    index,
    maxCardsVisible,
    onMoveDownMenuButtonClick,
    onMoveLeftMenuButtonClick,
    onMoveRightMenuButtonClick,
    onMoveUpMenuButtonClick,
    onRemoveMenuButtonClick,
  ])

  return (
    <>
      <div
        className={'dx-card responsive-paddings card'}
        id={card === Card.ActivitiesSummaryCard ? 'costCenterPieContainer' : undefined}
      >
        <div className={'card-content'}>
          <div className="header">
            <div>
              {card === Card.NextCommitmentsCard && (
                <div>
                  <Person personQuery="me" view={'fourlines'} personCardInteraction={'click'} showPresence={true} />
                </div>
              )}
              <h4 className={'card-title'}>
                {card === Card.NextCommitmentsCard && 'Prossimi impegni'}
                {card === Card.ReminderCard && 'Promemoria'}
                {card === Card.FromYourAccountCard && 'Dal tuo account'}
                {card === Card.ActivitiesSummaryCard && 'Riepilogo attività ultima settimana'}
                {card === Card.OrdersToProcessCard && 'Ordini da evadere'}
                {card === Card.TasksToCompleteCard && 'Task aperti'}
                {card === Card.TicketsSummaryCard && 'Riepilogo ticket aperti/assegnati'}
                {card === Card.AnalysisToCompleteCard && 'Analisi aperte'}
              </h4>
            </div>
            <CardMenu menuItems={menuItems}></CardMenu>
            {card === Card.NextCommitmentsCard && <NextCommitmentsCard></NextCommitmentsCard>}
            {card === Card.ReminderCard && <ReminderCard></ReminderCard>}
            {card === Card.FromYourAccountCard && <FromYourAccountCard></FromYourAccountCard>}
            {card === Card.ActivitiesSummaryCard && (
              <ActivitiesSummaryCard getCurrentEmployee={getCurrentEmployee}></ActivitiesSummaryCard>
            )}
            {card === Card.OrdersToProcessCard && <OrdersToProcessCard></OrdersToProcessCard>}
            {card === Card.TasksToCompleteCard && (
              <TasksToCompleteCard getCurrentEmployee={getCurrentEmployee}></TasksToCompleteCard>
            )}
            {card === Card.TicketsSummaryCard && <TicketsSummaryCard></TicketsSummaryCard>}
            {card === Card.AnalysisToCompleteCard && (
              <AnalysisToCompleteCard getCurrentEmployee={getCurrentEmployee}></AnalysisToCompleteCard>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default DashboardCard
